import { useEffect } from "react";
import { useSearchParams } from "react-router-dom";
import Layout from "../../layouts/Layout";
import { RegistrationFormProvider, useRegistrationForm } from "./core/RegistrationFormProvider";
import ConfirmationTab from "./tabs/ConfirmationTab";
import ContactInformationTab from "./tabs/ContactInformationTab";
import HealthInformationTab from "./tabs/HealthInformationTab";
import PickupInformationTab from "./tabs/PickupInformationTab";
import SelectCampTab from "./tabs/SelectCampTab";
import StudentInformationTab from "./tabs/StudentInformationTab";
import { GetCamp } from "../../services/RegisterService";

export default function RegistrationForm() {
	return (
		<RegistrationFormProvider>
			<RegistrationFormContent />
		</RegistrationFormProvider>
	);
}

const RegistrationFormContent = () => {
	const { registerData, setRegisterData, camps } = useRegistrationForm();
	const { step, selectedCamp } = registerData || {};
	const campImage = selectedCamp?.id === 102 ? "/avigail-transparent.png" : undefined;

	let campTopContent = null;
	if (campImage && selectedCamp) {
		let discountDate = selectedCamp.discount_price_ends_at || selectedCamp.discount_price_ends;
		let useDiscount = !!selectedCamp.discount_price;
		if (discountDate) {
			const today = new Date(); today.setHours(0, 0, 0, 0);
			const ends = new Date(discountDate); ends.setHours(0, 0, 0, 0);
			useDiscount = ends >= today;
			discountDate = [ends.getDate(), ends.getMonth() + 1, ends.getFullYear()].join("/");
		}
		campTopContent = (
			<div className="text-white text-center drop-shadow">
				{useDiscount ? (
					<>
						<span className="text-2xl font-bold">₪{selectedCamp.discount_price}</span>
						<span className="text-base line-through text-white/60 mr-2">₪{selectedCamp.price}</span>
						{discountDate && <div className="text-sm text-white/70 mt-0.5">מחיר מוקדם עד {discountDate}</div>}
					</>
				) : (
					<span className="text-2xl font-bold">₪{selectedCamp.price}</span>
				)}
			</div>
		);
	}

	const [searchParams] = useSearchParams();
	const campParam = searchParams.get("camp");
	const couponParam = searchParams.get("coupon");

	useEffect(() => {
		if (couponParam) {
			setRegisterData((prev) => ({ ...prev, couponCode: couponParam }));
		}
	}, [couponParam]);

	useEffect(() => {
		if (!campParam || (step && step >= 2)) return;

		const campIdInt = parseInt(campParam);

		if (camps != null) {
			const campFromList = camps.find((c) => c.id === campIdInt);
			if (campFromList) {
				setRegisterData({ selectedCamp: campFromList, step: 2, canChangeCamp: false });
				return;
			}
		}

		GetCamp(campParam)
			.then((camp) => {
				setRegisterData({ selectedCamp: camp, step: 2, canChangeCamp: false });
			})
			.catch((err) => {
				console.error("Failed to load camp:", err);
			});
	}, [campParam, camps]);

	/*
	{"selectedCamp":{"id":5,"name":"קייטנה לבדיקה","registrations_opened":true,"price":1250,"discount_price":null,"discount_price_ends_at":null,"reminders_at":"2024-04-17","created_at":"2024-02-19T09:41:52.000000Z","updated_at":"2024-04-02T15:33:45.000000Z","deleted_at":null}
	,"step":6,"first_name":"תמיר","last_name":"נחום","grade":"2","class_number":"2","gov_id":"212345676","birthdate":"2015-10-24","address":"אנגל 78","shirt_size":"14","gender":"female","hmo":"מכבי כפר סבא",
	"contact_information":{"mother_name":"תמיר","father_name":"תום","email":"tamir@thm.co.il","mother_phone_prefix":"054","mother_phone":"0543000745","father_phone_prefix":"054","father_phone":"0543000745","emergency_name":"תמיר","emergency_closeness":"אח","emergency_phone_prefix":"054","emergency_phone":"0543000745","workers_committee":false,"workers_committee_id":null,"workers-committee":false},
	"pickup_information":{"pickup_city":"10","pickup_school":"47","pickup_type":"ילדי חוזר הביתה בכוחות עצמו","pickup_contact_name":"","pickup_contact_phone":"","pickup_contact_closeness":"","pickup_agree":true,"comment":""},
	"health_information":{"healthy":true,"has_sensitivities":false,"sensitivities":"","risky_sensitivities":"","can_swim":true,"contact_name":"תמיר","contact_gov_id":"123123422","contact_phone_prefix":"054","contact_phone":"0543000745","terms_agree":true},
	"coupon":{"code":"1231235","discount":120,"expiring_at":"2024-04-17T21:00:00.000000Z"}}
	*/

	const hasCampParam = !!campParam;
	const waitingForCamp = hasCampParam && (!step || step < 2);

	return (
		<Layout topImage={campImage} topContent={campTopContent}>
			{waitingForCamp && (
				<div className="flex items-center justify-center text-white text-xl font-semibold">
					טוען...
				</div>
			)}
			{!hasCampParam && (!step || step === 1) && <SelectCampTab />}
			{step === 2 && <StudentInformationTab />}
			{step === 3 && <ContactInformationTab />}
			{step === 4 && <PickupInformationTab />}
			{step === 5 && <HealthInformationTab />}
			{step === 6 && <ConfirmationTab />}
		</Layout>
	);
};
